import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { IBreadCrumb } from '../data-models/Ibreadcrumb.interface';

@Injectable()
export class BreadcrumbsService {
    public breadcrumbs = new BehaviorSubject<Array<IBreadCrumb>>(null);
}
